const module = { name: 'fd-header/locationDropdown', exports: {} }; const exports = module.exports;

function init() {
    const toggles = document.querySelectorAll('[data-location-toggle]');
    toggles.forEach((btn) => {
        const wrap = btn.closest('.brand-bar__location-dropdown-wrap');
        if (!wrap)
            return;
        btn.addEventListener('click', () => {
            const isOpen = wrap.classList.toggle('is-open');
            btn.setAttribute('aria-expanded', isOpen);
        });
        wrap.addEventListener('focusout', (e) => {
            const nextFocus = e.relatedTarget;
            if (nextFocus && wrap.contains(nextFocus))
                return;
            wrap.classList.remove('is-open');
            btn.setAttribute('aria-expanded', 'false');
        });
    });
    document.querySelectorAll('[data-location-option]').forEach((option) => {
        option.addEventListener('click', () => {
            const wrap = option.closest('.brand-bar__location-dropdown-wrap');
            document.dispatchEvent(new CustomEvent('brandbar:countrySelect', {
                bubbles: true,
                detail: {
                    code: option.dataset.countryCode,
                    name: option.dataset.countryName,
                },
            }));
            if (wrap) {
                wrap.classList.remove('is-open');
                const btn = wrap.querySelector('[data-location-toggle]');
                if (btn)
                    btn.setAttribute('aria-expanded', 'false');
            }
        });
    });
    document.addEventListener('click', (e) => {
        document.querySelectorAll('.brand-bar__location-dropdown-wrap.is-open').forEach((wrap) => {
            if (!wrap.contains(e.target)) {
                wrap.classList.remove('is-open');
                const btn = wrap.querySelector('[data-location-toggle]');
                if (btn)
                    btn.setAttribute('aria-expanded', 'false');
            }
        });
    });
}
module.exports = { init };
export default module.exports;